import implementationGuideForms from "../../data/implementationGuideForms";
import { ImplementationGuideForm } from "../../types";

// This function sorts the IG forms by their 'form_index' property.
const sortedForms: ImplementationGuideForm[] = implementationGuideForms.sort(
  (a: ImplementationGuideForm, b: ImplementationGuideForm) => {
    return a.form_index - b.form_index;
  },
);

export default sortedForms;
